import autosize from 'autosize'

export default function insertAtCaret(textarea, newText) {
  const caretStart = textarea.selectionStart || 0
  const caretEnd = textarea.selectionEnd || 0
  const originalText = textarea.value
  const leadingText = originalText.substring(0, caretStart)
  const trailingText = originalText.substring(caretEnd, originalText.length)
  textarea.value = leadingText + newText
  textarea.focus()
  textarea.value = leadingText + newText + trailingText
  textarea.dispatchEvent(new Event('input'))

  // Using newText.length for this calculation ends up with a too big range as newText has different line breaks \r\n
  textarea.setSelectionRange(leadingText.length, textarea.value.length - trailingText.length)
  autosize.update(textarea)
}
